import { getInfo, setInfo } from '@/utils/storage'
export default {
  namespaced: true,
  state () {
    return {
      userInfo: getInfo()
    }
  },
  mutations: {
    setUserInfo (state, obj) {
      state.userInfo = obj
      setInfo(state.userInfo)
    }
  },
  actions: {
    logout (context) {
      context.commit('setUserInfo', {})
    }
  },
  getters: {}
}
